import React from "react";
import { motion } from "framer-motion";
import { pageMotion } from "../../framer/animation";
import SliderPage from "../../components/SliderPage/SliderPage";
import { Title } from "../../styles/reusables";
import { FaMailBulk } from "react-icons/fa";
import { ContactForm } from "../../components/ContactForm/ContactForm";
import { ContactSection } from "./styles";
import { SiTelegram, SiLinkedin } from "react-icons/si";

const Contact = () => {
	return (
		<>
			<SliderPage />
			<motion.div
				variants={pageMotion}
				initial='hidden'
				animate='show'
				exit='exit'
			>
				<Title>
					<FaMailBulk />
					<h2>Contact me</h2>
				</Title>
				<ContactSection>
					<div className='form-container'>
						<h3>Write me a message</h3>
						<ContactForm />
					</div>
					<div className='contacts'>
						<h3>Contact me via</h3>
						<ul>
							<li>
								<a
									href='https://www.linkedin.com/in/amirkhon-shakirov-6a7535219'
									rel='noreferrer'
									target='_blank'
								>
									<SiLinkedin />
									Linkedin
								</a>
							</li>
							<li>
								<a
									href='https://t.me/ASpiritx'
									rel='noreferrer'
									target='_blank'
								>
									<SiTelegram />
									Telegram
								</a>
							</li>
						</ul>
					</div>
				</ContactSection>
			</motion.div>
		</>
	);
};

export default Contact;
